<section class="mis_dropdown">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="dropfilter__flex">
                    <div class="drop__widthone">
                        <div class="dropsearch_flex">
                            <div class="dropwidth">
                                <select name="dropdown" class="mis_select" id="dropdown"
                                    >
                                    <option value="1">All</option>
                                    <option value="2">State</option>
                                    <option value="3">City</option>
                                    <option value="4">Campus</option>
                                </select>
                            </div>
                            <div class="searchwidth">
                                <div class="input-group">
                                    <input type="text" class="form-control misinput_control" placeholder="Search"
                                       >
                                    <div class="input-group-btn">
                                        <button class="btn drop_iconsearch" type="submit">
                                            <i class="fa fa-search" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drop__widthtwo">
                        <button class="dropdown-toggle month_dropshow" type="button" data-toggle="dropdown">
                            <img src="../../assets/image/filter.png" alt="filter" class="cctv_filter">
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right mis_select_show">
                            <li><a href="#" class="dropdown-item">HTML</a></li>
                            <li><a href="#" class="dropdown-item">CSS</a></li>
                            <li><a href="#" class="dropdown-item">JavaScript</a></li>
                        </ul>
                    </div>

                </div>
            </div>
            <div class="col-md-12">
                <div class="search_mobshow">
                    <div>
                        <h6 class="mob_searchhd">Search by</h6>
                    </div>
                    <div class="searchitem_scroll">
                        <ul class="search_items">
                            <li><a href="#">Admission no </a></li>
                            <li><a href="#">School</a></li>
                            <li><a href="#">State</a></li>
                            <li><a href="#">Zone</a></li>
                            <li><a href="#">City</a></li>
                            <li><a href="#">Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="state__sec">
                    <ul class="state__list">
                        <li *ngFor="let data of building">
                            <div class="statelist__flex">
                                <div class="statetitle__flex">
                                    <div>
                                        <h5 class="state__name">{{data.buildingName}} {{data.buildingId}}
                                        </h5>
                                       
                                    </div>
                                    <div>
                                        <h6 class="state__dvr">Total DVR : <span
                                                class="dvr__color">{{data.totalDvrs}}</span></h6>
                                    </div>
                                </div>
                                <div class="cctv__colflex">
                                    <div class="cctv__camflex">
                                        <div>
                                            <figure class="mb-0">
                                                <img src="../../assets/image/cctv.jpg" class="cctv" alt="cctv">
                                            </figure>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title">CCTV Installed</h6>
                                            <h5 class="cctv__number">{{data.totalCamerasInstalled}}</h5>
                                        </div>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title">Connected</h6>
                                        <h5 class="cctv__number">{{data.totalConnected}}</h5>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title">Not Connected</h6>
                                        <h5 class="cctv__number">{{data.totalNotConnected}}</h5>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title">Streaming</h6>
                                        <h5 class="cctv__number">{{data.totalVideoStreaming}}</h5>
                                    </div>
                                    <div>
                                        <h6 class="cctv__title">No Video</h6>
                                        <h5 class="cctv__number">{{data.totalVideoNotStreaming}}</h5>
                                    </div>
                                    <div>
                                        <figure class="mb-0">
                                            <!-- <img routerLink="/dvr/{{data.cctvDetId}}" -->
                                            <img routerLink="/cctvcampus/{{data.cctvDetId}}"
                                                src="../../assets/image/rightarrow.png" class="rightarrow"
                                                alt="rightarrow">
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
